import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { importProvidersFrom, APP_INITIALIZER, inject, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt);

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { AnmcoBackendApiModule } from './api-clients/generated/services/AnmcoBackend/api.module';
import { Configuration } from './api-clients/generated/services/AnmcoBackend/configuration';
import { environment } from './environments/environment';
import { JsBridgeService } from './core/services/js-bridge.service';
import { LocalStorageService } from './core/services/local-storage.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { StorageProperties } from './core/enums/storage-properties.enum';
import { AuthService } from './core/services/auth.service';
import { ProfileService } from './app/pages/profile/profile.service';

function initializeApp(): () => Promise<void> {
  const bridge = inject(JsBridgeService);
  const authService = inject(AuthService);
  const profileService = inject(ProfileService);

  return async () => {
    bridge.getSharedValues(Object.values(StorageProperties));
    await bridge.valuesReady;

    if (authService.isAuthenticated()) {
      try {
        await profileService.loadProfile();
      } catch {
        // Errore propagato: AppComponent apre ProfileErrorModal tramite orchestrator
      }
    }

    bridge.appInitEnd();
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ animated: false }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
    },
    importProvidersFrom(
      AnmcoBackendApiModule.forRoot(() => {
        const localStorageService = inject(LocalStorageService);
        return new Configuration({
          basePath: environment.apiUrl,
          accessToken: () => localStorageService.getAccessToken() || '',
        });
      })
    ),
  ],
});
